import type { Components, Theme } from "@mui/material/styles";
import type { ComponentProps } from "react";
import { selectClasses } from "@mui/material/Select";
import { inputAdornmentClasses } from "@mui/material/InputAdornment";
import { ChevronDownIcon } from "../shared/icons";

const IconComponent = (props: ComponentProps<typeof ChevronDownIcon>) => <ChevronDownIcon {...props} />;

export const MuiSelect: Components<Theme>["MuiSelect"] = {
  defaultProps: { variant: "outlined", IconComponent },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,
      borderRadius: theme.shape.borderRadius,
      [`& .${selectClasses.select}`]: { padding: `7.5px ${theme.spacing(6)} 7.5px ${theme.spacing(2)} !important` },
      [`& .${selectClasses.icon}`]: { fontSize: "14px", right: "10px", color: theme.palette.text.primary },
      [`& .${selectClasses.select} ~ .${inputAdornmentClasses.root}`]: {
        position: "static",
        right: "auto",
        transform: "none",
      },
    }),
    select: ({ theme }) => ({ borderRadius: theme.shape.borderRadius, padding: 0 }),
    iconOpen: ({ theme }) => ({ color: theme.palette.text.primary }),
  },
};
